import { Component, Input, OnInit } from '@angular/core';
import { APIWithLoaderHelper } from '@app/data/helpers/apiWithLoaderHelper';
import { forkJoin, Observable } from 'rxjs';
import { LocationParamsService } from '@app/data/services/locationParamsService';
import { switchMap } from 'rxjs/operators';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChartService } from '@app/data/services/chartService';
import { take } from 'rxjs/operators';
import moment from 'moment';
import {
  MaramatakaApiResult,
  MaramatakaApiResultLunarDays,
  MaramatakaDaysApiItem,
  MataurangaApiResult,
  MataurangaApiResultLunar,
} from '@app/data/services/types/Maramataka';

@Component({
  selector: 'app-rongo-observation-summary',
  templateUrl: './rongo-observation-summary.component.html',
  styleUrls: ['./rongo-observation-summary.component.scss'],
})
export class RongoObservationSummaryComponent implements OnInit {
  @Input() observation: any;

  constructor(
    private apiWithLoaderHelper: APIWithLoaderHelper,
    private locationParamsService: LocationParamsService,
    private sanitizer: DomSanitizer,
    private chartService: ChartService
  ) {}

  public sanitizedLayoutHtml: SafeHtml | undefined;
  public energyLevel: string | undefined;
  public lunarStageEng: string | undefined;
  public lunarStageReo: string | undefined;
  public lunarMonth: string | undefined;

  get currentHost(): string {
    return window.location.origin;
  }

  ngOnInit() {
    if (!this.observation?.id) {
      return;
    }
    this.getObservationLayout(this.observation.id).subscribe((layout) => {
      this.sanitizedLayoutHtml = this.sanitizer.bypassSecurityTrustHtml(layout);
    });

    const observationDate = moment.utc(this.observation.date);
    const localDate = observationDate.clone().tz('Pacific/Auckland');
    const startOfDay = localDate.clone().startOf('day').toISOString();
    const endOfDay = localDate.clone().endOf('day').toISOString();

    //TODO: this should all live in a service somewhere
    forkJoin([
      this.chartService.getMaramataka().pipe(take(1)),
      this.chartService.getMaramatakaDays(startOfDay, endOfDay).pipe(take(1)),
      this.chartService.getMatauranga(startOfDay, endOfDay).pipe(take(1)),
    ]).subscribe(
      ([maramatakaResult, maramatakaDaysResult, mataurangaApiResult]: [
        MaramatakaApiResult,
        MaramatakaDaysApiItem[],
        MataurangaApiResult
      ]) => {
        if (maramatakaDaysResult.length > 0) {
          const lunarDayData = maramatakaDaysResult[0];
          const lunarDayId = lunarDayData.maramataka_lunar_month_day_id;
          const maramatakaDayData = maramatakaResult.lunarMonthDays.find(
            (m: MaramatakaApiResultLunarDays) => m.id.toString() === lunarDayId
          );
          const dayMatauranga = mataurangaApiResult.daysWithMatauranga.find(
            (d: MataurangaApiResultLunar) => d.maramataka_lunar_month_day_id === lunarDayId
          );

          this.lunarMonth = lunarDayData.maramataka_month_id;

          if (maramatakaDayData) {
            this.lunarStageEng = maramatakaDayData.name_english === '0' ? '-' : maramatakaDayData.name_english;
            this.lunarStageReo = maramatakaDayData.name_reo_maori;
          }
          this.energyLevel = maramatakaDayData?.energy_text_english;
        }
      }
    );
  }

  private getObservationLayout(observationId: number): Observable<any> {
    return this.locationParamsService.getUrlWithParams(`/rongo/observation/${observationId}/layout`).pipe(
      switchMap((urlWithParams) => {
        return this.apiWithLoaderHelper.getText<string>(urlWithParams);
      })
    );
  }
}
